/**
 * @param {unknown} value
 * @returns {number|undefined}
 */
const toOptionalInt = (value) => {
    if (value == null || value === '') {
        return undefined;
    }
    const raw = Array.isArray(value) ? value[0] : value;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : undefined;
};

/**
 * Builds query params for GET /logistics/v1/crossDockPurchaseOrders.
 * @param {Object} params
 * @returns {URLSearchParams}
 */
export const buildCrossDockPurchaseOrderListParams = (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.limit !== undefined) {
        queryParams.set('limit', String(params.limit));
    }
    if (params.offset !== undefined) {
        queryParams.set('offset', String(params.offset));
    }

    const id = toOptionalInt(params.id);
    if (id !== undefined) {
        queryParams.set('id', String(id));
    }

    const purchaseOrderId = toOptionalInt(params.purchaseOrderId);
    if (purchaseOrderId !== undefined) {
        queryParams.set('purchaseOrderId', String(purchaseOrderId));
    }

    const packagingPurchaseOrderId = toOptionalInt(params.packagingPurchaseOrderId);
    if (packagingPurchaseOrderId !== undefined) {
        queryParams.set('packagingPurchaseOrderId', String(packagingPurchaseOrderId));
    }

    if (params.scheduledDeliveryDateStart) {
        queryParams.set('scheduledDeliveryDateStart', params.scheduledDeliveryDateStart);
    }
    if (params.scheduledDeliveryDateEnd) {
        queryParams.set('scheduledDeliveryDateEnd', params.scheduledDeliveryDateEnd);
    }

    if (params.facilityIds?.length) {
        params.facilityIds.forEach((facilityId) => queryParams.append('facilityIds[]', facilityId));
    }
    if (params.crossDockIds?.length) {
        params.crossDockIds.forEach((crossDockId) => queryParams.append('crossDockIds[]', crossDockId));
    }
    if (params.statuses?.length) {
        params.statuses.forEach((status) => queryParams.append('statuses[]', status));
    }

    return queryParams;
};
